/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownAwardSignatureType } from '../models/db_DropdownAwardSignatureType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AwardSignatureTypes {
    /**
     * Get a list of award signature types
     * @returns db_DropdownAwardSignatureType OK
     * @throws ApiError
     */
    public static listAwardSignatureTypes(): CancelablePromise<Array<db_DropdownAwardSignatureType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/award-signature-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
